import React, { useMemo } from 'react';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';

const TableLogData = ({ data }) => {
  console.log('###################> TableLogData DATA:', data);
  
  const columns = useMemo(() => [
    {
      accessorKey: 'name', // access nested data with dot notation
      header: 'Name'
    },
    {
      accessorKey: 'modules',
      header: 'Modules'
    },
    {
      accessorKey: 'sessionCount', // normal accessorKey
      header: 'Sessions (Trainee/Org)'
    },
    {
      accessorKey: 'negotiationTime',
      header: 'Negotiation (min)'
    },
    {
      accessorKey: 'negotiations',
      header: 'Negotiations'
    }
  ]);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    enableGrouping: true,
    enableStickyHeader: true,
    enableStickyFooter: true,
    initialState: {
      density: 'xs',
      expanded: true,
      // grouping: ['negotiation'],
      pagination: { pageIndex: 0, pageSize: 20 },
      // sorting: [{ id: 'negotiation', desc: false }],
      mantineTableContainerProps: { sx: { height: '80%' } }
    }
  });

  return <MantineReactTable table={table} />;
};

export default React.memo(TableLogData);
